import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import { Toaster } from 'sonner';

import '@fontsource-variable/inter/wght.css';
import '@fontsource-variable/maven-pro/wght.css';

import './index.css';
import styles from './index.module.css';

import { Auth0ProviderWithHistory } from '@features/auth';
import { muiTheme } from '@dynamon-as/ui/themes';
import { NotificationContainer } from '@dynamon-as/ui';
import { GlobalLoader } from '@shared/components';
import { I18nProvider } from '@shared/i18n/components';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element not found');
}
const root = createRoot(rootElement);

// Router adapter for Auth0ProviderWithHistory that works with react-router v7
const routerAdapter = {
    navigate: (path: string): void => {
        // Navigate using window.location for initial redirect
        if (typeof window !== 'undefined') {
            window.location.href = path;
        }
    },
};

// Get organization ID from environment
const organizationId = import.meta.env.VITE_ORGANIZATION_ID;

root.render(
    <React.StrictMode>
        <Auth0ProviderWithHistory
            router={routerAdapter}
            organization={organizationId}
        >
            <I18nProvider>
                <ThemeProvider theme={muiTheme}>
                    <Toaster
                        position="top-right"
                        richColors
                    />
                    <NotificationContainer position="top-right" />
                    <Suspense
                        fallback={
                            <GlobalLoader className={styles.loadingSpinner} />
                        }
                    >
                        <App />
                    </Suspense>
                </ThemeProvider>
            </I18nProvider>
        </Auth0ProviderWithHistory>
    </React.StrictMode>,
);
